import {
	BeachAccessOutlined,
	EventBusyOutlined,
	SwapHoriz,
} from "@mui/icons-material";
import { Box, Link, Typography } from "@mui/material";
import React from "react";
import { Link as RouterLink } from "react-router-dom";

import colors from "../../../config/colors";
import { QueueGroup } from "../controllers/use-supervisor-queue";
import { QueueItemType } from "../store/supervisor-home-types";
import QueueItemRow from "./queue-item-row";

const GROUP_ICONS: Record<QueueItemType, React.ReactNode> = {
	openShift: <EventBusyOutlined sx={{ fontSize: "20px" }} />,
	shiftSwap: <SwapHoriz sx={{ fontSize: "20px" }} />,
	timeOff: <BeachAccessOutlined sx={{ fontSize: "20px" }} />,
};

interface ActionQueueGroupProps {
	group: QueueGroup;
}

function ActionQueueGroup({ group }: ActionQueueGroupProps) {
	return (
		<Box
			sx={{
				border: `1px solid ${colors.border}`,
				borderRadius: "10px",
				overflow: "hidden",
				mb: 2,
			}}
		>
			<Box
				sx={{
					display: "flex",
					alignItems: "center",
					gap: 1.25,
					padding: "12px 16px",
					backgroundColor: "#F5F5F5",
					borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
				}}
			>
				<Box sx={{ display: "flex", color: colors.stepperBackground }}>
					{GROUP_ICONS[group.type]}
				</Box>
				<Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
					{group.title}
				</Typography>
				<Typography sx={{ fontSize: "12px", color: colors.gray }}>
					{group.countLabel}
				</Typography>
				<Box sx={{ flex: 1 }} />
				<Link
					component={RouterLink}
					to={group.url}
					sx={{ fontSize: "13px", fontWeight: 500 }}
				>
					{group.linkLabel}
				</Link>
			</Box>

			{group.rows.map((row, index) => (
				<QueueItemRow
					key={row.id}
					row={row}
					isLast={index === group.rows.length - 1}
				/>
			))}
		</Box>
	);
}

export default ActionQueueGroup;
